export class IdValue<TValue> {
  constructor(public id: number = null, public value: TValue = null) { }
}
